import httpClientService from '@/services/httpClientService';
export default {
	getLoginMethods: () =>
		httpClientService.Get('/UserContextModule/api/Login/method'),

	getClients: () => httpClientService.Get('/UserContextModule/api/Clients'),
	getSelectedClient: () =>
		httpClientService.Get('/UserContextModule/api/Clients/Selected'),

	getProjects: () => httpClientService.Get('/UserContextModule/api/Projects'),
	getSelectedProject: () =>
		httpClientService.Get('/UserContextModule/api/Projects/Selected'),
	getSelectedProjectSettings: () =>
		httpClientService.Get(
			'/UserContextModule/api/Projects/Selected/Settings'
		),
	getPermissions: () =>
		httpClientService.Get('/UserContextModule/api/User/GetUserPermissions'),

	downloadFile: (id) =>
		httpClientService.Get(
			`/UserContextModule/api/File/DownloadFile?id=${id}`,
			{
				responseType: 'blob',
			}
		),

	updateSelectedProject: (item) =>
		httpClientService.Post('/UserContextModule/api/Projects', item),
	updateSelectedClient: (item) =>
		httpClientService.Post('/UserContextModule/api/Clients', item),

	changePassword: (item) =>
		httpClientService.Post(
			'/UserContextModule/api/User/ChangePassword',
			item
		),

	getNotifications: () =>
		httpClientService.Get('/UserContextModule/api/Notifications'),
	deleteNotification: (id) =>
		httpClientService.Delete(`/UserContextModule/api/Notifications/${id}`),
};
